
<template>
  <div class="promotionTitle-component" :style="{backgroundImage: backgroundImage && `url(${backgroundImage || bgImage})`}">{{name || ''}} <span v-if="showMore" @click="goMore">更多<code>>></code></span> </div>
</template>

<script >
export default {
    name: 'promotionTitle',
    props: {
        name: {
            type: String,
            required: true
        },
        backgroundImage: {
            type: String
        },
        showMore: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            bgImage: require('../../../assets/images/common/floor_bg.png')
        }
    },
    created () {

    },
    activated () {

    },
    mounted () {

    },
    methods: {
        goMore () {
            this.$emit('goMore')
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "../../../assets/stylus/variables";

.promotionTitle-component
    position relative
    width 100%
    height 120px
    line-height 120px
    text-align center
    background-size 100% 100%
    color #fae8bd
    font-size $fontLarger
    overflow hidden
    span
        position absolute
        top 0
        right 20px
        z-index 9
        text-align right
        font-size $fontSmall
        color $fcWhite
</style>
